<div class="unauthorized">
  <h1>Access Denied</h1>
  <p>You do not have permission to view this page.</p>
  <a routerLink="/">Go to Home</a>
</div>

